import { SubmissionStatus } from '@/api/types';

/** Human-readable (Slovenian) label for a numeric SubmissionStatus ordinal. */
export const SUBMISSION_STATUS_LABELS: Record<SubmissionStatus, string> = {
  [SubmissionStatus.Draft]: 'Osnutek',
  [SubmissionStatus.Submitted]: 'Oddano',
  [SubmissionStatus.Accepted]: 'Sprejeto',
  [SubmissionStatus.Rejected]: 'Zavrnjeno',
};

export function submissionStatusLabel(status: SubmissionStatus): string {
  return SUBMISSION_STATUS_LABELS[status] ?? `Neznano (${status})`;
}

/**
 * Stable English key for Badge's color lookup (components/ui/Badge.tsx's
 * colorMap) - kept separate from the translated display label above.
 */
export const SUBMISSION_STATUS_TONES: Record<SubmissionStatus, string> = {
  [SubmissionStatus.Draft]: 'Draft',
  [SubmissionStatus.Submitted]: 'Submitted',
  [SubmissionStatus.Accepted]: 'Accepted',
  [SubmissionStatus.Rejected]: 'Rejected',
};

export function submissionStatusTone(status: SubmissionStatus): string {
  return SUBMISSION_STATUS_TONES[status] ?? 'Draft';
}
